import React, { useEffect } from 'react';
import '../assets/js/team.js';

function AdminTeam() {
    useEffect(() => {
        if (window.loadTeams) {
            window.loadTeams();
        }
    }, []);
    
    return (
        <div>
            <h1 className="bg-warning p-3 ">Admin Team Members</h1>

            <section>
                <div className="p-2 d-flex justify-content-between align-items-center">
                    <h2>All Team Members</h2>
                    <a href="#" id='addTeam' class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#teamModal">
                        <i class="fa-solid fa-plus"></i> Add
                    </a>
                </div>
                <div className="row px-lg-2">
                    <div className="col-12 overflow-scroll">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Sr No.</th>
                                    <th scope="col">Image</th>
                                    <th scope="col">Title</th>
                                    <th scope="col">Position</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody id='allTeamData'></tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Team Model */}
            <div class="modal fade" id="teamModal" tabindex="-1" aria-labelledby="teamModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title text-white" id="teamModalLabel">Add Member</h5>
                            <button type="button" class="btn-close border border-0 text-white btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="addTeamForm" enctype="multipart/form-data" class="p-3">
                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Name</b></label>
                                        <input type="text" name="name" id="name" class="form-control" required placeholder='enter name' />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Position</b></label>
                                        <input type="text" name="position" id="position" class="form-control" required placeholder='enter position' />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Member Image</b></label>
                                        <input type="file" className="form-control" id="image" name="image" />
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn fw-semibold btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Team Model */}

            {/* Edit Team Modal */}
            <div class="modal fade" id="editTeamModal" tabindex="-1">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content overflow-scroll">

                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title">Edit Team Member</h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <form id="editTeamForm" enctype="multipart/form-data" class="p-3">
                            <input type="hidden" id="editId" />

                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label><b>Name</b></label>
                                        <input type="text" id="editName" class="form-control" />
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label><b>Position</b></label>
                                        <input type="text" id="editPosition" class="form-control" />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label><b>Member Image</b></label>
                                        <input type="file" id="editImage" class="form-control" />
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* ✅ Universal Success Modal */}
            <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content border-0 shadow-lg">

                        <div class="modal-header bg-success text-white">
                            <h5 class="modal-title fw-bold" id="successModalLabel">
                                <i class="bi bi-check-circle-fill me-2"></i> Success
                            </h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
                            </svg>
                            <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                        </div>

                        <div class="modal-footer border-0 justify-content-center">
                            <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default AdminTeam;